/*
 * Core
 * */

import { useTranslation } from "react-i18next";

import { ReactComponent as Icon } from "assets/shared/img/ic_empty_token.svg";

export const EmptyToken = () => {
  const { t } = useTranslation("updatePassword");

  return (
    <div className={"empty-token-wrap"}>
      <div className={"icon"}>
        <Icon />
      </div>
      <p className={"title"}>{t("tokenEmpty")}</p>
      <p className={"text"}>{t("contactToSolve")}</p>
      <a
        className={"button"}
        href={`mailto:${import.meta.env.VITE_APP_MULTI_SITE_SUPPORT_EMAIL}`}
      >
        {t("contactSupport")}
      </a>
    </div>
  );
};
